import GoogleLoginButton from "./providers/GoogleLoginButton";
import FacebookLoginButton from "./providers/FacebookLoginButton";

export const AuthOptions = ({ setView, onHide }) => {
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  return (
    <>
      <div className="auth-modal-title">Log In or Sign Up to Watch for Free</div>

      <GoogleLoginButton onHide={onHide} clientId={clientId} />
      <FacebookLoginButton onHide={onHide} />
      <div className="auth-divider">OR</div>

      <div className="auth-link-text" onClick={() => setView("login")}>
        Login / Sign Up with Email
      </div>
    </>
  );
};
